if (!customElements.get('collection-load-more')) {
  customElements.define(
    'collection-load-more',
    class CollectionLoadMore extends HTMLElement {
      constructor() {
        super();
        this.addEventListener('click', this.onClick.bind(this));
      }

      onClick(event) {
        const backToTop = event.target.closest('[data-back-to-top]');
        if (backToTop) {
          event.preventDefault();
          window.scrollTo({ top: 0, behavior: 'smooth' });
          document.getElementById('MainContent')?.focus({ preventScroll: true });
          return;
        }

        const button = event.target.closest('[data-load-more]');
        if (!button) return;

        event.preventDefault();
        this.loadMore(button);
      }

      async loadMore(button) {
        if (button.getAttribute('aria-disabled') === 'true') return;

        const grid = document.getElementById('product-grid');
        if (!grid) {
          window.location.href = button.href;
          return;
        }

        button.setAttribute('aria-disabled', 'true');
        button.classList.add('loading');
        button.querySelector('.loading__spinner')?.classList.remove('hidden');

        try {
          // The section rendering API returns only this grid, not the whole page.
          const url = new URL(button.href, window.location.origin);
          if (this.dataset.sectionId) url.searchParams.set('section_id', this.dataset.sectionId);

          const response = await fetch(url);
          if (!response.ok) throw new Error(`Load more failed: ${response.status}`);

          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          const nextGrid = html.getElementById('product-grid');
          const nextFooter = html.querySelector('collection-load-more');
          if (!nextGrid) throw new Error('Load more: product grid missing');

          const template = document.createElement('template');
          template.innerHTML = nextGrid.innerHTML;
          // Products appended below the fold must not wait for the scroll reveal animation.
          template.content.querySelectorAll('.scroll-trigger').forEach((element) => {
            element.classList.add('scroll-trigger--cancel');
          });

          grid.append(template.content);

          if (nextFooter) this.innerHTML = nextFooter.innerHTML;
        } catch (error) {
          console.error(error);
          window.location.href = button.href;
        } finally {
          button.removeAttribute('aria-disabled');
          button.classList.remove('loading');
          button.querySelector('.loading__spinner')?.classList.add('hidden');
        }
      }
    }
  );
}
